/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreditScoreRequest } from '../model';
// @ts-ignore
import { CreditScoreResponse } from '../model';
/**
 * CreditScoreApi - axios parameter creator
 * @export
 */
export const CreditScoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation will process credit scoring through credit scoring services in Credify backend (e.g. FinScore).
         * @summary Request credit score
         * @param {CreditScoreRequest} creditScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCreditScoring: async (creditScoreRequest: CreditScoreRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'creditScoreRequest' is not null or undefined
            assertParamExists('requestCreditScoring', 'creditScoreRequest', creditScoreRequest)
            const localVarPath = `/v1/credit-score`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = creditScoreRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreditScoreApi - functional programming interface
 * @export
 */
export const CreditScoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreditScoreApiAxiosParamCreator(configuration)
    return {
        /**
         * This operation will process credit scoring through credit scoring services in Credify backend (e.g. FinScore).
         * @summary Request credit score
         * @param {CreditScoreRequest} creditScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestCreditScoring(creditScoreRequest: CreditScoreRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestCreditScoring(creditScoreRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CreditScoreApi - factory interface
 * @export
 */
export const CreditScoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreditScoreApiFp(configuration)
    return {
        /**
         * This operation will process credit scoring through credit scoring services in Credify backend (e.g. FinScore).
         * @summary Request credit score
         * @param {CreditScoreRequest} creditScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCreditScoring(creditScoreRequest: CreditScoreRequest, options?: any): AxiosPromise<CreditScoreResponse> {
            return localVarFp.requestCreditScoring(creditScoreRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CreditScoreApi - interface
 * @export
 * @interface CreditScoreApi
 */
export interface CreditScoreApiInterface {
    /**
     * This operation will process credit scoring through credit scoring services in Credify backend (e.g. FinScore).
     * @summary Request credit score
     * @param {CreditScoreRequest} creditScoreRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditScoreApiInterface
     */
    requestCreditScoring(creditScoreRequest: CreditScoreRequest, options?: AxiosRequestConfig): AxiosPromise<CreditScoreResponse>;

}

/**
 * CreditScoreApi - object-oriented interface
 * @export
 * @class CreditScoreApi
 * @extends {BaseAPI}
 */
export class CreditScoreApi extends BaseAPI implements CreditScoreApiInterface {
    /**
     * This operation will process credit scoring through credit scoring services in Credify backend (e.g. FinScore).
     * @summary Request credit score
     * @param {CreditScoreRequest} creditScoreRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditScoreApi
     */
    public requestCreditScoring(creditScoreRequest: CreditScoreRequest, options?: AxiosRequestConfig) {
        return CreditScoreApiFp(this.configuration).requestCreditScoring(creditScoreRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
